(() => {
  'use strict';
  const source = document.getElementById('NoiseCommerceConfig');
  if (!source) return;
  let config;
  try { config = JSON.parse(source.textContent); } catch { return; }
  const root = `${config.root || '/'}`.replace(/\/?$/, '/');
  const labels = config.labels;
  const isComposition = (name) => /^(composizione|composition)$/i.test(String(name).trim());
  const displayName = (value) => {
    const text = String(value || '');
    return text === text.toLocaleUpperCase() ? text.charAt(0).toLocaleUpperCase() + text.slice(1).toLocaleLowerCase() : text;
  };
  function variantLabel(product, variant) {
    const names = (product.options || []).map(option => typeof option === 'string' ? option : option.name);
    const values = variant.options || variant.title.split(' / ');
    return values.filter((value, index) => !isComposition(names[index] || '') && !/%/.test(value))
      .map((value, index) => /^(taglia|size)$/i.test(names[index] || '') || /^(XX?S|S|M|L|X{1,4}L)(\/\d+)?$/i.test(value) ? value : displayName(value))
      .join(' · ');
  }
  // Run before Palo Alto reads option IDs; hidden composition follows the visible choices.
  document.addEventListener('change', (event) => {
    const selectors = event.target.closest('variant-selects');
    if (!selectors || !selectors.querySelector('[data-noise-composition]')) return;
    const matrix = selectors.querySelector('[data-noise-variant-matrix]');
    if (!matrix) return;
    let variants;
    try { variants = JSON.parse(matrix.textContent); } catch { return; }
    const wrappers = [...selectors.querySelectorAll('[data-option-position]')];
    const matches = variants.filter(variant => wrappers.every(wrapper => {
      if (wrapper.hasAttribute('data-noise-composition')) return true;
      const input = wrapper.querySelector('input:checked, [data-popout-input]');
      return !input || variant.options[Number(wrapper.dataset.optionPosition) - 1] === input.value;
    }));
    const variant = matches.find(item => item.available) || matches[0];
    if (!variant) return;
    wrappers.filter(wrapper => wrapper.hasAttribute('data-noise-composition')).forEach(wrapper => {
      const value = variant.options[Number(wrapper.dataset.optionPosition) - 1];
      wrapper.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === value; });
      const input = wrapper.querySelector('[data-popout-input]');
      const option = [...wrapper.querySelectorAll('[data-popout-option]')].find(option => option.dataset.value === value);
      if (input && option) {
        input.value = value;
        const entry = option.closest('[data-option-value-id]');
        if (entry) {
          input.dataset.optionValueId = entry.dataset.optionValueId;
          if (entry.dataset.productUrl) input.dataset.productUrl = entry.dataset.productUrl;
        }
      }
    });
  }, true);
  let cart = config.cart;
  let cartRequest;
  let refreshTimer;
  let adding = false;
  let history = [];
  const cache = new Map();
  const historyKey = 'noise-look-interest-v3';
  const historyTTL = 30 * 24 * 60 * 60 * 1000;
  const money = (amount) => new Intl.NumberFormat(config.locale || 'it', {
    style: 'currency', currency: cart.currency || config.currency || 'EUR'
  }).format(Number(amount) / 100);
  const node = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  const preferencesAllowed = () => Boolean(config.historyEnabled &&
    window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true &&
    window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true);
  function loadHistory() {
    if (!preferencesAllowed()) {
      history = [];
      try { localStorage.removeItem(historyKey); sessionStorage.removeItem('noise-product-interest-v1'); } catch {}
      return;
    }
    try {
      const data = JSON.parse(localStorage.getItem(historyKey) || '[]');
      history = Array.isArray(data) ? data.filter((entry) =>
        entry && typeof entry.handle === 'string' && /^[a-zA-Z0-9_-]+$/.test(entry.handle) &&
        Number.isFinite(entry.time) && entry.time <= Date.now() && Date.now() - entry.time < historyTTL
      ).slice(0, 12) : [];
    } catch { history = []; }
  }
  function remember(handle, id, details = {}) {
    if (!preferencesAllowed() || !handle) return;
    loadHistory();
    history = [{handle, id: Number(id) || null, type: String(details.type || ''), title: String(details.title || ''), color: String(details.color || ''), price: Number(details.price) || 0, time: Date.now()},
      ...history.filter((entry) => entry.handle !== handle)].slice(0, 12);
    try { localStorage.setItem(historyKey, JSON.stringify(history)); } catch {}
  }
  function currentProduct() {
    const element = document.querySelector('noise-recommendations[data-context="product"]');
    const match = window.location.pathname.match(/\/products\/([^/]+)/);
    if (element && match) remember(decodeURIComponent(match[1]), element.dataset.productId, lookContext(element));
  }
  function lookContext(element) {
    const info = element.closest('product-info') || document.querySelector('product-info');
    const wrapper = [...(info?.querySelectorAll('[data-option-position]') || [])].find(item => /colore|color|colour/i.test(item.querySelector('legend, .select__label, .label-typography')?.textContent || ''));
    const color = wrapper?.querySelector('input:checked, [data-popout-input]')?.value || '';
    let tags = [];
    try { tags = JSON.parse(element.dataset.productTags || '[]'); } catch {}
    let price = Number(element.dataset.productPrice) || 0;
    try {
      const variants = JSON.parse(info?.querySelector('[data-noise-variant-matrix]')?.textContent || '[]');
      const wrappers = [...(info?.querySelectorAll('variant-selects [data-option-position]') || [])];
      const selected = variants.find(variant => wrappers.length && wrappers.every(item => {
        const input = item.querySelector('input:checked, [data-popout-input]');
        return !input || variant.options[Number(item.dataset.optionPosition) - 1] === input.value;
      }));
      if (selected) price = Number(selected.price) || price;
    } catch {}
    return {id: Number(element.dataset.productId), type: element.dataset.productType || '', title: element.dataset.productTitle || '', price, tags: Array.isArray(tags) ? tags : [], color};
  }
  const normalize = value => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  function productColors(product) {
    if (Array.isArray(product.colors)) return product.colors.map(normalize);
    const names = (product.options || []).map(option => typeof option === 'string' ? option : option.name);
    const index = names.findIndex(name => /^(colore|color|colour)$/i.test(name));
    return index < 0 ? [] : [...new Set((product.variants || []).filter(variant => variant.available).map(variant => normalize(variant.options?.[index])))];
  }
  function interestScore(product, context, interests) {
    let score = 0;
    const text = normalize(`${product.title || ''} ${(product.tags || []).join(' ')}`);
    const terms = normalize(`${context.title || ''} ${(context.tags || []).join(' ')}`).split(/[^a-z0-9]+/).filter(term => term.length > 3 && !/giubb|piumin|magli|pantal|scar|basic|noise/.test(term));
    score += [...new Set(terms)].filter(term => text.includes(term)).length * 12;
    const colors = productColors(product);
    if (context.color && colors.includes(normalize(context.color))) score += 24;
    else if (context.color && colors.some(color => /^(nero|black|bianco|white|grigio|grey|gray|avorio|beige)$/.test(color))) score += 6;
    const price = Number(product.price) || Number(product.variants?.find(variant => variant.available)?.price) || 0;
    if (context.price && price) score += Math.max(0, 6 - Math.abs(Math.log(price / context.price)) * 4);
    interests.forEach((entry, index) => {
      const weight = Math.max(1, 12 - index);
      if (entry.handle === product.handle || Number(entry.id) === Number(product.id)) score += 60 + weight * 2;
      const words = normalize(`${entry.title || ''} ${entry.type || ''}`).split(/[^a-z0-9]+/).filter(word => word.length > 3 && !/giubb|piumin|magli|pantal|scar|basic|noise/.test(word));
      score += [...new Set(words)].filter(word => text.includes(word)).length * weight;
      if (entry.color && colors.includes(normalize(entry.color))) score += weight;
    });
    let tie = 0;
    for (const character of `${context.id || ''}:${context.color || ''}:${product.id || ''}`) tie = (tie * 31 + character.charCodeAt(0)) >>> 0;
    return score + (tie % 997) / 997;
  }
  function updateShipping() {
    document.querySelectorAll('noise-shipping-progress').forEach((element) => {
      const visible = config.country === 'IT' && cart.currency === 'EUR' &&
        config.threshold > 0 && cart.items.length > 0;
      element.hidden = !visible;
      if (!visible) return;
      const remaining = Math.max(0, config.threshold - cart.total_price);
      element.querySelector('.noise-shipping__message').textContent = remaining ?
        labels.shipping.replace('__NOISE_AMOUNT__', money(remaining)) : labels.qualified;
      element.querySelector('progress').value = Math.min(100,
        Math.max(0, cart.total_price / config.threshold * 100));
    });
  }
  async function readCart() {
    if (cartRequest) return cartRequest;
    cartRequest = fetch(`${root}cart.js`, {headers: {Accept: 'application/json'}, cache: 'no-store'})
      .then((response) => {
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      }).then((data) => {
        cart = data;
        updateShipping();
        return cart;
      }).finally(() => { cartRequest = null; });
    return cartRequest;
  }
  function scheduleRefresh() {
    document.querySelectorAll('noise-recommendations').forEach((element) => element.syncControls());
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(async () => {
      try {
        await readCart();
        document.querySelectorAll('noise-recommendations').forEach((element) => element.refresh());
      } catch {}
    }, 80);
  }
  function cachedJSON(url) {
    if (!cache.has(url)) {
      const request = fetch(url, {headers: {Accept: 'application/json'}, signal: typeof AbortSignal.timeout === 'function' ? AbortSignal.timeout(8000) : undefined}).then((response) => {
        if (!response.ok) throw new Error('Recommendations unavailable');
        return response.json();
      }).catch((error) => { cache.delete(url); throw error; });
      cache.set(url, request);
    }
    return cache.get(url);
  }
  const recommendations = async (id, intent) => {
    if (!id) return [];
    const url = `${root}recommendations/products.json?product_id=${encodeURIComponent(id)}&limit=10&intent=${intent}`;
    try { return (await cachedJSON(url)).products || []; } catch { return []; }
  };
  function safeProductURL(value) {
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) return null;
      return url.pathname + url.search;
    } catch { return null; }
  }
  function eligible(product, excluded) {
    return product?.available && !excluded.has(Number(product.id)) &&
      !product.requires_selling_plan && !product.gift_card &&
      !product.tags?.includes('_preorder') && safeProductURL(product.url) &&
      product.variants?.some((variant) => variant.available && variant.price > 0);
  }
  function rank(products, gap) {
    if (!(gap > 0)) return products;
    return products.map((product, index) => {
      const price = Math.min(...product.variants.filter((variant) => variant.available).map((variant) => variant.price));
      const score = price >= gap && price <= gap * 1.5 ? 0 : 1;
      return {product, index, score};
    }).sort((a, b) => a.score - b.score || a.index - b.index).map((entry) => entry.product);
  }
  function family(type) {
    const text = String(type || '').toLowerCase();
    if (/jeans|pantalon|bermuda|short|trouser/.test(text)) return 'bottom';
    if (/scarp|stival|sneaker|mocassin|shoe|boot/.test(text)) return 'shoes';
    if (/giacc|cappott|giubb|piumin|bomber|biker|blazer|jacket|coat/.test(text)) return 'outer';
    if (/abit[oi]|complet[oi]|suit/.test(text)) return 'suit';
    if (/magli|maglion|camici|t-shirt|felp|polo|cardigan|shirt|knit|hoodie/.test(text)) return 'top';
    return '';
  }
  function pairsWith(type, product) {
    const pairings = {bottom: ['top', 'outer', 'shoes'], top: ['bottom', 'outer', 'shoes'],
      outer: ['bottom', 'shoes', 'top'], suit: ['top', 'shoes'], shoes: ['top', 'bottom']};
    return Boolean(pairings[family(type)]?.includes(family(`${product.type || ""} ${product.title || ""}`)));
  }
  function diverse(products) {
    const categories = new Set();
    const first = [];
    const rest = [];
    products.forEach((product) => {
      const category = family(`${product.type || ""} ${product.title || ""}`);
      if (category && !categories.has(category)) { first.push(product); categories.add(category); }
      else rest.push(product);
    });
    return [...first, ...rest];
  }
  class NoiseRecommendations extends HTMLElement {
    connectedCallback() {
      this.generation = 0;
      this.signature = '';
      this.active = false;
      this.list = this.querySelector('.noise-recommendations__list');
      this.heading = this.querySelector('.noise-recommendations__heading');
      this.status = this.querySelector('.noise-recommendations__status');
      this.abort = new AbortController();
      this.addEventListener('submit', (event) => this.add(event), {signal: this.abort.signal});
      this.addEventListener('click', (event) => {
        if (event.target.closest('button[data-noise-add]')) this.add(event);
      }, {signal: this.abort.signal});
      if (!config.enabled) return;
      if (this.dataset.context === 'cart') {
        if (this.closest('[data-cart-page]')) this.activate();
        document.addEventListener('theme:cart:open', () => this.activate(), {signal: this.abort.signal});
      } else {
        this.activate();
      }
    }
    disconnectedCallback() {
      this.generation++;
      this.abort?.abort();
    }
    activate() {
      this.active = true;
      this.refresh();
    }
    syncControls() {
      this.querySelectorAll('.noise-recommendations__form').forEach((form) => {
        const select = form.querySelector('select');
        const button = form.querySelector('button');
        if (button) button.disabled = adding || Boolean(select && !select.value);
        if (select) select.disabled = adding;
      });
    }
    async refresh() {
      if (!this.active || !this.isConnected || !config.enabled) return;
      this.syncControls();
      const generation = ++this.generation;
      const inCart = this.dataset.context === 'cart';
      if (inCart && !cart.items.length) {
        this.hidden = true;
        this.signature = '';
        this.list.replaceChildren();
        return;
      }
      const seed = inCart ? cart.items[0]?.product_id : Number(this.dataset.productId);
      const context = inCart ? {id: seed, title: cart.items[0]?.product_title || cart.items[0]?.title || '', type: cart.items[0]?.product_type || '', price: cart.items[0]?.price || 0, color: cart.items[0]?.options_with_values?.find(option => /^(colore|color|colour)$/i.test(option.name))?.value || ''} : lookContext(this);
      loadHistory();
      const interests = preferencesAllowed() ? history.filter(entry => Number(entry.id) !== Number(seed)) : [];
      const seedType = inCart ? `${cart.items[0]?.product_type || ''} ${cart.items[0]?.product_title || cart.items[0]?.title || ''}` : `${this.dataset.productType || ''} ${this.dataset.productTitle || ''}`;
      const excluded = new Set(cart.items.map((item) => Number(item.product_id)));
      excluded.add(Number(seed));
      if (!inCart) excluded.add(Number(this.dataset.productId));
      const [complementaryResults, relatedResults] = await Promise.all([recommendations(seed, 'complementary'), recommendations(seed, 'related')]);
      const complementary = complementaryResults.filter(product => eligible(product, excluded));
      const related = relatedResults.filter(product => eligible(product, excluded));
      if (preferencesAllowed() && interests[0]?.id) related.push(...(await recommendations(interests[0].id, 'related')).filter(product => eligible(product, excluded)));
      let candidates = [...complementary, ...related].filter(product => pairsWith(seedType, product));
      // Fill missing outfit categories from the store's own collections, never a fixed product.
      const order = {outer: ['bottom', 'shoes', 'top'], top: ['bottom', 'shoes', 'outer'],
        bottom: ['top', 'shoes', 'outer'], shoes: ['bottom', 'top'], suit: ['shoes', 'top']}[family(seedType)] || [];
      let catalog = [];
      try { catalog = JSON.parse(document.getElementById('NoiseLookCatalog')?.textContent || '[]'); } catch {}
      if (!Array.isArray(catalog)) catalog = [];
      catalog = [...new Map(catalog.filter(product => product && typeof product.handle === 'string').map(product => [product.handle, product])).values()];
      for (const category of order.slice(0, 2)) {
        const pool = [...catalog, ...candidates].filter(product => family(`${product.type || ''} ${product.title || ''}`) === category && !excluded.has(Number(product.id)));
        const entries = [...new Map(pool.map(product => [product.handle, product])).values()].sort((a, b) => interestScore(b, context, interests) - interestScore(a, context, interests));
        // Bounded requests; products and available variants are checked again at request time.
        const hydrated = await Promise.all(entries.slice(0, 3).map(async entry => {
          if (!/^[a-zA-Z0-9_-]+$/.test(entry.handle)) return null;
          try {
            const product = entry.variants ? entry : await cachedJSON(`${root}products/${encodeURIComponent(entry.handle)}.js`);
            product.url ||= `${root}products/${entry.handle}`;
            return eligible(product, excluded) && pairsWith(seedType, product) ? product : null;
          } catch { return null; }
        }));
        for (const product of hydrated) {
          if (product && !candidates.some(candidate => candidate.id === product.id)) candidates.push(product);
        }
      }
      let isLook = candidates.length > 0;
      // For unclassified items, retain explicitly configured Shopify complementary products.
      if (!order.length) { candidates = complementary; isLook = candidates.length > 0; }
      if (order.length) candidates.sort((a, b) => order.indexOf(family(`${a.type || ''} ${a.title || ''}`)) - order.indexOf(family(`${b.type || ''} ${b.title || ''}`)));
      if (generation !== this.generation || !this.isConnected) return;
      const seen = new Set();
      candidates = candidates.filter((product) => {
        if (seen.has(product.id)) return false;
        seen.add(product.id);
        return true;
      });
      const currentInterests = preferencesAllowed() ? interests : [];
      candidates.sort((a, b) => interestScore(b, context, currentInterests) - interestScore(a, context, currentInterests));
      if (order.length) candidates.sort((a, b) => order.indexOf(family(`${a.type || ''} ${a.title || ''}`)) - order.indexOf(family(`${b.type || ''} ${b.title || ''}`)));
      if (isLook) candidates = diverse(candidates);
      candidates = candidates.slice(0, 2);
      const signature = JSON.stringify([isLook, context.color, candidates.map((product) => product.id)]);
      if (signature !== this.signature) {
        this.signature = signature;
        this.heading.textContent = isLook ? labels.look : labels.related;
        this.list.replaceChildren(...candidates.map((product) => this.card(product)));
      }
      this.hidden = !candidates.length;
      this.syncControls();
    }
    card(product) {
      const card = node('article', 'noise-recommendations__card');
      card.dataset.productId = product.id;
      const url = safeProductURL(product.url);
      const imageLink = node('a', 'noise-recommendations__image');
      imageLink.href = url;
      imageLink.tabIndex = -1;
      imageLink.setAttribute('aria-hidden', 'true');
      const imageSource = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.url;
      if (imageSource) {
        const imageURL = new URL(imageSource, window.location.origin);
        if (['https:', 'http:'].includes(imageURL.protocol)) {
          imageURL.searchParams.set('width', '160');
          const image = node('img');
          image.src = imageURL.href;
          image.alt = '';
          image.width = 68;
          image.height = 90;
          image.loading = 'lazy';
          imageLink.append(image);
        }
      }
      const body = node('div', 'noise-recommendations__body');
      const title = node('a', 'noise-recommendations__title', displayName(product.title));
      title.href = url;
      const available = product.variants.filter((variant) => variant.available && variant.price > 0);
      const single = product.has_only_default_variant || product.variants.length === 1;
      const prices = available.map((variant) => variant.price);
      const price = node('span', 'noise-recommendations__price',
        `${Math.min(...prices) !== Math.max(...prices) ? labels.from + ' ' : ''}${money(Math.min(...prices))}`);
      const inForm = Boolean(this.closest('form'));
      const form = node(inForm ? 'div' : 'form', 'noise-recommendations__form');
      if (!inForm) {
        form.action = `${root}cart/add`;
        form.method = 'post';
      }
      form.dataset.productId = product.id;
      const select = node('select', 'noise-recommendations__select');
      if (!inForm) select.name = 'id';
      select.required = true;
      select.setAttribute('aria-label', `${labels.options} · ${product.title}`);
      if (!single) {
        select.append(new Option(labels.choose, '', true, true));
        select.options[0].disabled = true;
      }
      const shownLabels = new Set();
      available.forEach((variant) => {
        const label = variantLabel(product, variant);
        if (shownLabels.has(label)) return;
        shownLabels.add(label);
        const option = new Option(label, variant.id);
        option.dataset.price = variant.price;
        option.dataset.minimum = variant.quantity_rule?.min || 1;
        select.append(option);
      });
      const button = node('button', 'noise-recommendations__add', labels.add);
      button.type = inForm ? 'button' : 'submit';
      if (inForm) button.dataset.noiseAdd = '';
      button.disabled = !single;
      button.setAttribute('aria-label', `${labels.add} · ${product.title}`);
      select.addEventListener('change', () => {
        button.disabled = !select.value;
        price.textContent = money(select.selectedOptions[0].dataset.price);
      });
      const input = node('input');
      input.type = 'hidden';
      if (!inForm) input.name = 'quantity';
      input.value = '1';
      if (single) {
        select.value = available[0].id;
        const id = node('input');
        id.type = 'hidden';
        if (!inForm) id.name = 'id';
        id.dataset.noiseVariant = '';
        id.value = available[0].id;
        form.append(id);
        form.dataset.minimum = available[0].quantity_rule?.min || 1;
      } else {
        form.append(select);
      }
      form.append(input, button);
      body.append(title, price, form);
      card.append(imageLink, body);
      return card;
    }
    async add(event) {
      const form = event.target.closest('.noise-recommendations__form');
      if (!form) return;
      event.preventDefault();
      if (adding || (form.reportValidity && !form.reportValidity())) return;
      const button = form.querySelector('button');
      const select = form.querySelector('select');
      if (select && !select.reportValidity()) return;
      const data = form.tagName === 'FORM' ? new FormData(form) : new FormData();
      if (form.tagName !== 'FORM') data.set('id', select?.value || form.querySelector('[data-noise-variant]').value);
      data.set('quantity', select?.selectedOptions[0]?.dataset.minimum || form.dataset.minimum || '1');
      adding = true;
      button.disabled = true;
      if (select) select.disabled = true;
      button.textContent = labels.adding;
      this.status.textContent = '';
      const cartElement = document.querySelector('cart-items');
      cartElement?.disableCartButtons?.();
      let success = false;
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', body: data, headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || labels.error);
        success = true;
        const addedId = Number(result.product_id || form.dataset.productId);
        if (!cart.items.some((item) => Number(item.product_id) === addedId)) {
          cart.items.unshift({product_id: addedId, product_type: result.product_type});
        }
        this.status.textContent = labels.added;
        button.textContent = labels.added;
        if (typeof cartElement?.getCart === 'function') cartElement.getCart();
        else window.location.assign(`${root}cart`);
        try { await readCart(); } catch {}
        document.querySelectorAll('noise-recommendations').forEach((element) => element.refresh());
      } catch (error) {
        this.status.textContent = success ? labels.added : error.message || labels.error;
      } finally {
        adding = false;
        button.disabled = false;
        if (select) select.disabled = false;
        button.textContent = labels.add;
        cartElement?.enableCartButtons?.();
        document.querySelectorAll('noise-recommendations').forEach((element) => element.syncControls());
      }
    }
  }
  class NoiseShippingProgress extends HTMLElement {
    connectedCallback() { updateShipping(); }
  }
  if (!customElements.get('noise-recommendations')) customElements.define('noise-recommendations', NoiseRecommendations);
  if (!customElements.get('noise-shipping-progress')) customElements.define('noise-shipping-progress', NoiseShippingProgress);
  ['theme:cart:loaded', 'theme:cart:added', 'theme:cart:open'].forEach((event) =>
    document.addEventListener(event, scheduleRefresh));
  document.addEventListener('visitorConsentCollected', () => {
    loadHistory();
    currentProduct();
    document.querySelectorAll('noise-recommendations').forEach((element) => element.refresh());
  });
  document.addEventListener('click', (event) => {
    if (!preferencesAllowed()) return;
    const link = event.target.closest('a[href*="/products/"]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin) return;
    const match = url.pathname.match(/\/products\/([^/]+)/);
    if (!match) return;
    const container = link.closest('[data-product-id]');
    let catalog = [];
    try { catalog = JSON.parse(document.getElementById('NoiseLookCatalog')?.textContent || '[]'); } catch {}
    const details = Array.isArray(catalog) ? catalog.find(product => product.handle === decodeURIComponent(match[1])) : null;
    remember(decodeURIComponent(match[1]), details?.id || container?.dataset.productId, details || {});
  });
  let variantRefresh;
  const refreshContext = () => {
    clearTimeout(variantRefresh);
    variantRefresh = setTimeout(() => {
      currentProduct();
      document.querySelectorAll('noise-recommendations[data-context="product"]').forEach(element => element.refresh());
    }, 100);
  };
  document.addEventListener('change', event => { if (event.target.closest('variant-selects')) refreshContext(); });
  document.addEventListener('theme:variant:prices-updated', refreshContext);
  document.addEventListener('variant:change', refreshContext);
  loadHistory();
  currentProduct();
  if (config.historyEnabled && !window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], (error) => {
      if (!error) { loadHistory(); currentProduct(); document.querySelectorAll('noise-recommendations').forEach(element => element.refresh()); }
    });
  }
})();
